// Api
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  GetHealthyPerkResponseDto,
  UpdateHealthyPerkRequestDto,
} from "types/healthyPerk";
// Constants
import { endpoints } from "consts";
// Utils
import { coreQuery } from "utils/baseQuery";
import { healthyPerkMapper, healthyPerkPayloadMapper } from "utils/mappers";

export const healthyPerkAPI = createApi({
  reducerPath: "healthyPerkAPI",
  baseQuery: coreQuery(),
  tagTypes: ["healthyPerk"],
  endpoints: build => ({
    getHealthyPerk: build.query<GetHealthyPerkResponseDto, void>({
      query: () => ({
        url: endpoints.healthyPerk,
        method: "GET",
      }),
      transformResponse: (
        response: GetHealthyPerkResponseDto,
      ): GetHealthyPerkResponseDto => healthyPerkMapper(response),
      providesTags: ["healthyPerk"],
    }),
    updatehealthyPerkByDay: build.mutation<void, UpdateHealthyPerkRequestDto>({
      query: data => ({
        url: endpoints.healthyPerk,
        method: "POST",
        data: healthyPerkPayloadMapper(data),
      }),
      invalidatesTags: ["healthyPerk"],
    }),
  }),
});

export const { useGetHealthyPerkQuery, useUpdatehealthyPerkByDayMutation } =
  healthyPerkAPI;
